const AirlineType = {
  SET_AIRLINE_BRAND_LIST: 'airline/set_airline_brand_list',
};

export default AirlineType;
